import { z } from "zod"

import { EDUCATION_LEVELS } from "@/constants/education"

// One shape for create and edit (PRD-60 chunk B). The institution is the one
// in the header scope and is added at submit; a school can't move
// institutions here. Changing the level on edit cascades to the campus's
// classrooms (backend-audited); existing materials keep their snapshot.
export const schoolSchema = z.object({
  name: z.string().trim().min(1, "required").max(200, "too_long"),
  city: z.string().trim().max(120, "too_long").optional(),
  state: z.string().trim().max(120, "too_long").optional(),
  cct: z.string().trim().max(20, "too_long").optional(),
  education_level: z.enum(EDUCATION_LEVELS),
})

export type SchoolInput = z.infer<typeof schoolSchema>

// One shape for create and rename.
export const subjectSchema = z.object({
  name: z.string().trim().min(1, "required").max(200, "too_long"),
})

export type SubjectInput = z.infer<typeof subjectSchema>
